import React from 'react';
import fr from 'facet-rest';
import { pickFunction } from 'Helpers/Affordances';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import PaymentChangeViewButton from './PaymentChangeViewButton';

const PaymentChangeViewPicker = (props) => {
  const { pageContentResource } = usePageContentContext();

  return pickFunction(pageContentResource, {
    [fr.relationships.paymentChangeView.name]: () => {
      return (
        <PaymentChangeViewButton {...props} />
      );
    },
    [fr.relationships.default.name]: () => {
      return null;
    },
  });
};

export default PaymentChangeViewPicker;
